package org.dronda.service.wishlist.core.domain

import kotlinx.datetime.LocalDate
import kotlin.uuid.Uuid

enum class EventMode {
    STANDARD,
    SECRET_SANTA,
}

data class WishlistUser(
    val id: Uuid,
    val email: String,
    val name: String,
)

data class WishlistEvent(
    val id: Uuid,
    val name: String,
    val date: LocalDate,
    val mode: EventMode,
    val budget: String?,
)

data class WishlistSummary(
    val id: Uuid,
    val name: String,
    val owner: WishlistUser,
)

data class EventDetails(
    val event: WishlistEvent,
    val wishlists: List<WishlistSummary>,
    val isAdmin: Boolean,
    val santa: SantaViewerStatus?,
)

/**
 * Secret Santa state from the point of view of the viewer. Only ever contains the viewer's own recipient.
 */
data class SantaViewerStatus(
    val isDrawn: Boolean,
    val recipientId: Uuid?,
)

data class CreatedEvent(
    val id: Uuid,
    val unknownEmails: List<String>,
)

data class NewEvent(
    val name: String,
    val date: LocalDate,
    val mode: EventMode,
    val budget: String?,
    val participantEmails: List<String>,
    val exclusions: List<EmailExclusion>,
)

data class EmailExclusion(
    val emailA: String,
    val emailB: String,
    val direction: SantaExclusionDirection,
)

data class EventUpdate(
    val name: String,
    val date: LocalDate,
    val mode: EventMode,
    val budget: String?,
)
